import * as React from 'react';
import { IgcIconButtonComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A button that displays a single icon, designed for compact, icon-only
 * interactions such as toolbar actions, floating action buttons, or inline
 * controls.
 *
 * The icon is sourced from the icon registry via the `name` and `collection`
 * attributes. Like the normal button, it can render as an anchor element when
 * `href` is set and is fully form-associated.
 * @slot  - Optional label rendered alongside the icon, useful for accessibility or augmented layouts.
 * @csspart base - The wrapping element of the icon button.
 * @csspart icon - The icon element of the icon button.
 * @class
 */
export const IgrIconButton = /* @__PURE__ */ createComponent({
  tagName: 'igc-icon-button',
  displayName: 'IgrIconButton',
  elementClass: Component,
  react: React,
});

export type IgrIconButton = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrIconButtonModule = Component;
